import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { SecondaryLogoComponent } from '../secondary-logo/secondary-logo.component';
import { RouterModule, Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IconName } from '@app/utils/enums/icon-enum';
import { AppRoutes } from '@app/utils/enums/routes.enum';
import { UserStateService } from '@app/services/user-state/user-state.service';
import { AuthService } from '@app/services/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackModalComponent } from '../feedback-modal/feedback-modal.component';

@Component({
  selector: 'app-home-header',
  standalone: true,
  imports: [IconComponent, SecondaryLogoComponent, MatMenuModule, TranslateModule, RouterModule],
  templateUrl: './home-header.component.html',
  styleUrl: './home-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeHeaderComponent implements OnInit {
  public IconName = IconName;
  public appRoutes = AppRoutes;

  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly userStateService = inject(UserStateService);
  private readonly authService = inject(AuthService);
  private readonly dialog = inject(MatDialog);

  public userPhotoSignal = this.userStateService.headerPhotoUrl;
  public userDataSignal = this.userStateService.userData;

  ngOnInit(): void {
    this.userStateService.updateUserState().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  public openFeedbackModal(): void {
    this.dialog.open(FeedbackModalComponent, {
      width: '800px',
      maxWidth: '100vw',
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'feedback-dialog',
    });
  }

  public getInitials(): string {
    const data = this.userStateService.userData()?.data;

    if (!data) return '';

    return (data.firstName[0] + data.lastName[0]).toUpperCase();
  }

  public onImageError(): void {
    this.userStateService.setPhotoUrl('');
    this.userStateService.headerPhotoUrl.set('');
  }

  protected logout(): void {
    this.authService.logout();
    this.userStateService.resetState();
    this.router.navigate([AppRoutes.LOGIN]);
  }
}
